// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"ErrorPage_pageContainer__2UxAE","btnContainer":"ErrorPage_btnContainer__PIStq"};